import { render, staticRenderFns } from "./ProjectSectionContent.vue?vue&type=template&id=649b385e"
import script from "./ProjectSectionContent.vue?vue&type=script&lang=js"
export * from "./ProjectSectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports